var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.localShow
    ? _c(
        _vm.tagName,
        { tag: "component", class: _vm.currentClass },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.dismissible
            ? _c(
                "span",
                {
                  ref: "close",
                  class: _vm.closeButtonClass,
                  on: { click: _vm.hide }
                },
                [
                  _vm._t("close", [
                    _c(
                      "svg",
                      {
                        class: _vm.closeIconClass,
                        attrs: {
                          role: "button",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 20 20"
                        }
                      },
                      [
                        _c("title", [_vm._v(_vm._s(_vm.closeButtonTitle))]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
                          }
                        })
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }